import deviceDetector from 'mobile-device-detect'
import moment from 'moment-timezone'
import transformSourceIntoPlatform from '@/functions/transformSourceIntoPlatform'
import { getCookie } from '@/functions/cookies'

export function sendNetcore (eventName, userData, eventData) {
  const hostName = location.hostname.trim().toLowerCase()
  const envString = ['.dev.', '.staging.', 'localhost']
  const listId = envString.some(env => hostName.includes(env)) ? 7 : 3
  let flagPrakerja = userData.prakerja_id && userData.prakerja_id !== '' ? 'true' : 'false'
  let prakerjaSchedule = {}
  const additionalInfo = {
    source: deviceDetector.isMobile ? 'mweb' : 'web',
    screen_url: window.location.href
  }

  if (eventData?.is_prakerja_user === 'true') {
    flagPrakerja = 'true'
  }

  if (getCookie('currentPrakerjaSchedule').length) {
    prakerjaSchedule = JSON.parse(JSON.parse(getCookie('currentPrakerjaSchedule')))
  }

  const uData = {
    'pk^email': userData?.email,
    FULL_NAME: userData?.name ?? '',
    USER_ID: userData?.id ?? '',
    EMAIL: userData?.email ?? '',
    USER_PROFESSION: userData?.profession_name ?? '',
    MOBILE: userData?.phone ?? '',
    GENDER: userData?.gender ?? '',
    AGE: userData?.age ?? '',
    DATE_OF_BIRTH: userData?.birth_date ?? '0000-00-00',
    USER_YEAR_LEVEL: userData?.year_level_name ?? '',
    USERNAME: userData?.username ?? '',
    COMPANY_NAME: userData?.desired_company ?? '',
    REGISTRATION_PLATFORM: transformSourceIntoPlatform(userData?.source ?? ''),
    REGISTRATION_SOURCE: userData?.source ?? '',
    BIDANG_STUDI: userData?.bidang_studi_interests?.map(bidangStudi => bidangStudi.name).join(', ') ?? '',
    FIRST_PRAKERJA_TRANSACTION_AT: moment(userData?.prakerja_first_transaction).format('YYYY-MM-DD HH:mm:ss'),
    LAST_PRAKERJA_TRANSACTION_AT: moment(userData?.prakerja_last_transaction).format('YYYY-MM-DD HH:mm:ss'),
    IS_WHATSAPP_NUMBER: String(!!userData?.is_phone_refilled),
    ...prakerjaSchedule
  }

  if (eventData?.is_prakerja_user) {
    uData.IS_PRAKERJA_USER = flagPrakerja
  }

  /* eslint-disable no-undef */
  smartech('identify', userData?.email ?? '')
  smartech('contact', listId, userData?.email ? uData : '')
  smartech('dispatch', eventName, { ...additionalInfo, ...eventData })
  /* eslint-enable no-undef */
}
